import React from "react";
import PropTypes from "prop-types";
import PlayerPreview from "core/components/PlayerPreview";
import PlayerFooter from "core/components/PlayerFooter";
import { useCast } from "core/components/CastProvider";
import Typography from "@mui/material/Typography";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const StatusRoot = styled("div")(({ theme }) => ({
  display: "flex",
  width: "auto",
  position: "absolute",
  minHeight: 56,
  alignItems: "center",
  left: theme.spacing(1),
  right: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    left: theme.spacing(2),
    right: theme.spacing(2),
    top: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    left: theme.spacing(3),
    right: theme.spacing(3),
    top: theme.spacing(3),
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export default function PreviewScreen({ content, hideShare, hideLogo }) {
  const { t } = useTranslation("core");
  const {
    playerState,
    currentTime,
    duration,
    playOrPause,
    device,
    isMuted,
    volume,
    muteOrUnmute,
    setVolumeLevel,
    seek,
    nowSeek,
  } = useCast();

  let status;

  if (playerState === "PLAYING") {
    status = "playing";
  } else if (playerState === "PAUSED") {
    status = "paused";
  } else if (playerState === "BUFFERING") {
    status = "buffering";
  }

  const onClickPlay = () => {
    playOrPause();
  };
  const onClickPause = () => {
    playOrPause();
  };

  const handleSeekStart = () => {
    // if (status !== "paused") {
    //   playOrPause();
    // }
  };

  const handleSeekEnd = (value) => {
    seek(value);
  };

  const videoActions = {
    toggleMute: () => {
      muteOrUnmute();
    },
    setVolume: (value) => {
      setVolumeLevel(value);
    },
  };

  const videoState = {
    status,
    currentTime,
    duration,
    cast: true,
    seeking: nowSeek,
    muted: isMuted,
    volume,
  };

  return (
    <PlayerPreview preview={content.preview}>
      {device && (
        <StatusRoot>
          <CastConnectedIcon />
          <StyledTypography variant="h6">
            {t("castVideoScreen.youCastOnDevice", {
              name: device.friendlyName,
            })}
          </StyledTypography>
        </StatusRoot>
      )}
      <PlayerFooter
        content={content}
        onClickPlay={onClickPlay}
        onClickPause={onClickPause}
        onSeekEnd={handleSeekEnd}
        onSeekStart={handleSeekStart}
        position="absolute"
        visible
        hideShare={hideShare}
        hideLogo={hideLogo}
        fullScreen={false}
        videoState={videoState}
        videoActions={videoActions}
      />
    </PlayerPreview>
  );
}

PreviewScreen.propTypes = {
  fullscreenTarget: PropTypes.string,
  hideShare: PropTypes.bool,
  hideLogo: PropTypes.bool,
  autoPlay: PropTypes.bool,
  hideTitle: PropTypes.bool,
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    preview: PropTypes.string,
    hideLogo: PropTypes.bool,
    rightholder: PropTypes.shape({
      isAdvEnabled: PropTypes.bool,
    }),
  }).isRequired,
  onClickPlay: PropTypes.func.isRequired,
};
